/**
 * Voice Report Dictation feature.
 *
 * All exports are gated behind the VOICE_DICTATION feature flag.
 * Import components and hooks from this barrel — the consuming code
 * checks the feature flag before rendering.
 * @module features/voice-report
 */

export { default as DictateButton } from "@/features/voice-report/components/organisms/DictateButton";
export { default as RecordingBar } from "@/features/voice-report/components/molecules/RecordingBar";
export { default as ProcessingOverlay } from "@/features/voice-report/components/molecules/ProcessingOverlay";
export { default as DictationBanner } from "@/features/voice-report/components/molecules/DictationBanner";
export { useDictation } from "./hooks/useDictation";
export { useAudioRecorder } from "./hooks/useAudioRecorder";
export { buildInjectionScript } from "./utils/webViewInjection";
export {
  dictationStatusVar,
  dictationResultVar,
  dictationTranscriptVar,
  dictationFilledFieldsVar,
  dictationProcessingMessageVar,
  dictationElapsedSecondsVar,
  dictationLiveTranscriptVar,
  resetDictationState,
} from "./stores/dictationStore";
export type { DictationStatus } from "./stores/dictationStore";
